import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { GenericDocEInvoicePostingQueueContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_generic_doc_einvoice_posting_queue_container.model';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel, PagingResponseModel } from '../shared/api-response.model';
import { Pagination } from '../shared';


@Injectable({
  providedIn: 'root'
})
export class PostingQueuePostToProcessService extends BaseApiTemplateService<GenericDocEInvoicePostingQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/generic-doc-posting-queues';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/generic-doc-posting-queues'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/generic-doc-posting-queues'
    this.httpClient = http;
  }

  postMultipleToProcess(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/process-posting-queues/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  postProcessToPostingQueue(dtoObject: any, entityHdrGuid: string, visa: ApiVisa): Observable<ApiResponseModel<GenericDocEInvoicePostingQueueContainerModel>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/process-posting-queues/login-entity-ep/" + entityHdrGuid;
    }
    return this.httpClient.post<ApiResponseModel<GenericDocEInvoicePostingQueueContainerModel>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getPostingQueueByCriteria(pagination: Pagination, entityHdrGuid: string, visa: ApiVisa): Observable<ApiResponseModel<GenericDocEInvoicePostingQueueContainerModel>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/login-entity-ep/query/" + entityHdrGuid;
    }

    const UrlByCriteria = customUrl + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocEInvoicePostingQueueContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
